export default{sources:{avif:"__VITE_ASSET__DuL2ybq7__ 60w",webp:"__VITE_ASSET__DiepZ9a1__ 60w"},img:{src:"__VITE_ASSET__DacSPZ0B__",w:60,h:60}};